export function formatPriceWithCurrency(amount: number, currency: string, locale = 'en', decimal?: number) {
  let localeStr = 'en-US';

  if (locale === 'cs') {
    localeStr = 'cs-CZ';
  } else if (locale === 'fi') {
    localeStr = 'fi-FI';
  }

  const formatOptions: Intl.NumberFormatOptions = {
    style: 'currency',
    currency: currency,
  };

  if (decimal !== undefined) {
    formatOptions.minimumFractionDigits = decimal;
    formatOptions.maximumFractionDigits = decimal;
  } else {
    formatOptions.minimumFractionDigits = 0;
    formatOptions.maximumFractionDigits = 0;
  }

  return new Intl.NumberFormat(localeStr, formatOptions).format(amount);
}